
import {Component, Vue, Watch} from 'vue-property-decorator';
import {sysRuleApi} from "@/api/sysRule";
import {IPage} from "@/js/page";
import SetTableColumns from "@/components/SetTableColumns.vue";
import logApi from "@/api/log";

@Component({
  name: "sys-rule-list",
  components: {SetTableColumns},
})
export default class SysNoticeList extends Vue {
  detailDialog = false;
  actData = '';
  screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)
  listParam: IPage = {
    size: 10,
    current: 1,
  };
  loading = true;
  total = 0;
  allSelected: Array<any> = [];
  datas = [] as any;
  showForm = false;//查询条件隐藏展示
  propParams = this.getPropParams();
  created() {
    this.loadData();
  }
  refresh() {
    this.allSelected = [];
    let $table = this.$refs.table as HTMLFormElement;
    $table.clearSelection();
    this.loadData();
  }

  pageSizeChange(val: number) {
    this.listParam.size = val;
    this.refresh();
  }

  getPropParams() {
    return {
      userName: '',
      start: '',
      end: '',
    }
  }
  pageCurrentChange(val: number) {
    this.listParam.current = val;
    this.loadData();
  }

  memberSelect(selection: any) {
    this.allSelected = selection;
  }

  onOperateBtn(mode: string) {
    const dataArr = this.allSelected as Array<any>;
    let id = 0;
    if (['Add'].indexOf(mode) === -1) {
      if (dataArr.length === 0) {
        this.$message.error("请先勾选");
        return;
      }
      if (dataArr.length > 1 && ["Edit", "View"].indexOf(mode) > -1) {
        this.$message.error("只能勾选一条");
        return;
      }
      if (['Release', 'Recall'].indexOf(mode) > -1) {
        this.batchReleaseOrRecall(dataArr, mode);
        return;
      }
      if (mode === 'Delete') {
        this.batchDelete(dataArr);
        return;
      }
      id = dataArr[0].id;
    }
    this.actData = dataArr[0].content;
    this.detailDialog = true;
  }

  toView(id: number){
    this.$router.push("/sys/rule/detail/View/" + id);
  }

  reset() {
    this.propParams = this.getPropParams();
    this.refresh();
  }


  batchReleaseOrRecall(dataArr: any, type: string) {
    const str = type == 'Release' ? '发布' : '撤回';
    this.$confirm('您勾选了:  ' + dataArr.length + '条规章制度，是否' + (str) + '？', '提示', {
      confirmButtonText: '是',
      cancelButtonText: '否',
      type: 'warning',
      dangerouslyUseHTMLString: true
    }).then(() => {
      sysRuleApi.batchPublishOrRecall(dataArr.flatMap((e: any) => e.id).join(","), (type === 'Release' ? 1 : 2)).then(r => {
        if (r.data.result === 0) {
          this.$message.success((str) + "成功！");
          this.refresh();
        }
      })
    })
  }


  batchDelete(dataArr: any) {
    this.$confirm('您勾选了:  ' + dataArr.length + '条日志，是否删除', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      logApi.delLog({
        ids: dataArr.flatMap((e: any) => e.id).join(",")
      }).then(r => {
        if (r.data.result === 0) {
          this.$message.success("删除成功");
          this.refresh();
        }
      })
    }).catch(() => {
      console.log("取消")
    });
  }

  loadData() {
    this.loading = true;
    logApi.pageList({...this.listParam, ...this.propParams}).then((r) => {
      if (r.data.result === 0) {
        this.loading = false;
        const {total, records} = r.data.data;
        this.datas = records;
        this.total = total;
      }
    });
  }
}
